var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRestoration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Restoration",
    transform: "translate(-455 -169)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4265",
    "data-name": "Rectangle 4265",
    width: 93,
    height: 93,
    rx: 10,
    transform: "translate(455 169)",
    fill: "#fbefff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "restore",
    transform: "translate(479.31 192.919)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9860",
    "data-name": "Path 9860",
    d: "M43.394,22.529A20.452,20.452,0,0,1,4.012,30.268a1.461,1.461,0,1,1,2.7-1.107,17.525,17.525,0,1,0,.028-13.334l.716-.656a1.461,1.461,0,1,1,1.973,2.154L5.55,20.885a1.465,1.465,0,0,1-.987.384,1.391,1.391,0,0,1-.257-.023,1.458,1.458,0,0,1-1.041-.768L1.149,16.37a1.461,1.461,0,1,1,2.6-1.338l.1.2a20.444,20.444,0,0,1,39.544,7.3Z",
    transform: "translate(0 0)",
    fill: "#a023c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9861",
    "data-name": "Path 9861",
    d: "M22.3,24.606a1.455,1.455,0,0,1-.875-.292l-5.842-4.382A1.458,1.458,0,0,1,15,18.764v-7.3a1.461,1.461,0,1,1,2.921,0v6.573l5.258,3.944A1.46,1.46,0,0,1,22.3,24.6Z",
    transform: "translate(6.455 3.647)",
    fill: "#a023c5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestoration);
export default __webpack_public_path__ + "static/media/Restoration.a0e16d9014f4aaa450335353089287d1.svg";
export { ForwardRef as ReactComponent };